module.exports = __webpack_public_path__ + "static/case-2-7366930ed49a68c367edc1a452ef43a1.jpg";